
import { mapActions, mapGetters, mapMutations } from "vuex";
import declension from "@/mixins/declension";

export default {
  mixins: [declension],
  data() {
    return {
      isActive: false,
      sortList: {
        "price|asc": "Цена: Сначала дешевле",
        "price|desc": "Цена: Сначала дороже",
        "run|asc": "Пробег: Минимальный",
        "year|desc": "Год: Сначала новее"
      },
      defaultSort: 'price|asc'
    };
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      sortModal: "modal/modal-choose/sort", // СОРТИРОВКА ДЛЯ КАТАЛОГА
      sort: "filters/filters/sort", // СОРТИРОВКА ДЛЯ ФИЛЬТРОВ
      viewModal: "modal/modal-choose/view", // ОТОБРАЖЕНИЕ ДЛЯ КАТАЛОГА
      viewFilter: "filters/filters/view", // ОТОБРАЖЕНИЕ ДЛЯ ФИЛЬТРОВ
      arrSet: "marks/marks/arrSet",
    }),
    isSet() {
      let set;
      if (
        this.arrSet.includes(this.$route.params.mark) &&
        this.$route.params.mark
      ) {
        set = this.$route.params.mark;
        return set;
      }
      return false
    },
    currentIcon() {
      if (this.sort.split("|")[1] === "asc") {
        return "icon-sort";
      } else {
        return "icon-sort-alt";
      }
    },
    currentSort() {
      if (this.modal) {
        return this.sortList[this.sortModal];
      } else {
        return this.sortList[this.sort];
      }
    }
  },
  mounted() {
    if (this.$route.query.sort && !this.modal) {
      this.sortChosen(this.$route.query.sort);
    } else {
      this.sortChosen(this.defaultSort)
    }
  },
  methods: {
    ...mapActions({
      getOffers: "modal/modal-choose/getOffers",
      openModal: "modal/modal-main/openModal"
    }),
    ...mapMutations({
      setSort: "filters/filters/SET_SORT", //СОРТИРВОКА ДЛЯ ФИЛЬТРОВ
      setModalSort: "modal/modal-choose/SET_MODAL_SORT", //СОРТИРВОКА ДЛЯ МОДАЛКИ КАТОАЛОГА
      setViewCatalog: "modal/modal-choose/SET_VIEW", //ОТОБРАЖЕНИЕ ДЛЯ МОДАЛКИ
      setViewFilters: "filters/filters/SET_VIEW", //ОТОБРАЖЕНИЕ ДЛЯ ФИЛЬТРОВ
      setLoadingFilters: "filters/filters/SET_LOADING",
      setLoadingCatalog: "modal/modal-choose/SET_LOADING",
      setFilterClick: "filters/filters/SET_IS_FILTER_CLICK"
    }),
    async changeView(type) {
      if (this.modal) {
        await this.setLoadingCatalog(true);
        await this.setViewCatalog(type);
        setTimeout(() => {
          this.setLoadingCatalog(false);
        }, 300);
      } else {
        await this.setLoadingFilters(true);
        await this.setViewFilters(type);
        setTimeout(() => {
          this.setLoadingFilters(false);
        }, 300);
      }
    },
    openFilter() {
      let payload = {
        modal_component: "modal-filter-mobile",
        modal_data: "filter-mobile",
        modal_title: "Фильтр"
      };
      this.openModal(payload);
    },
    async sortChosen(sort, value) {
      this.setFilterClick(true);
      if (sort === "mobile") {
        if (this.modal) {
          this.setModalSort(value);
          await this.getOffers();
        } else {
          let query = { sort: value };
          if (Number(this.$route.query.page) > 1) {
            query.page = 1;
          }
          this.setSort(value);
          await this.$router.push({ path: this.$route.fullPath, query: query });
        }
      } else {
        if (this.modal) {
          this.setModalSort(sort);
          await this.getOffers();
        } else {
          let query = { sort: sort };
          if (Number(this.$route.query.page) > 1) {
            query.page = 1;
          }
          this.setSort(sort);
          await this.$router.push({ path: this.$route.fullPath, query: query });
        }
      }
    }
  }
};
